import { render, staticRenderFns } from "./BlockedNumber.vue?vue&type=template&id=9128cd00"
import script from "./BlockedNumber.vue?vue&type=script&lang=js"
export * from "./BlockedNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports